export enum OrderStatus {
  ACCEPTED = 'Accepted',
  CANCELED = 'Canceled',
  FUTURE = 'Future',
  NEW = 'New',
  SUBMITTED = 'Submitted',
}
